document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("deferred-media.no_control video").forEach(video => video.controls = false);

    document.querySelectorAll(".video_banner, .product-media-container").forEach(wrapper => {

        const video = wrapper.querySelector("video");
        const soundButton = wrapper.querySelector(".icon-block:has(svg.sound)");
        const playButton = wrapper.querySelector(".icon-block:has(svg.play)");

        if (!video) return;

        // muted default
        if (video.muted && soundButton) {
            soundButton.classList.add("is-muted");
        }

        soundButton?.addEventListener("click", () => {
            video.muted = !video.muted;
            soundButton.classList.toggle("is-muted", video.muted);
        });

        playButton?.addEventListener("click", () => {
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }

            playButton.classList.toggle("is-paused", video.paused);
        });

        // keep UI synced
        video.addEventListener("play", () => {
            playButton?.classList.remove("is-paused");
        });

        video.addEventListener("pause", () => {
            playButton?.classList.add("is-paused");
        });

    });
    

    document.querySelectorAll('.hovercards:not(.static_text) .text-block h2, .hovercards:not(.static_text) .text-block p, .hovercards .related_prd_variant .variant-title').forEach(element => {
      if (element) {
        element.innerHTML = element.textContent.split(' ').map(word => 
            `<span>${word}</span>`
        ).join(' ');
      }
    });

   
    window.addEventListener("scroll", function () {
        const fixBtn = document.querySelector(".fixed_btn.section");
        const newsletter = document.querySelector(".newsletter");

        if (!fixBtn || !newsletter) return;
        const rect = newsletter.getBoundingClientRect();
        const scrolledPast500 = window.scrollY > 500;
        const newsletterAtBottom =  rect.top <= window.innerHeight;

        if (scrolledPast500 && !newsletterAtBottom) {
            fixBtn.classList.add("scrolled");
        } else {
            fixBtn.classList.remove("scrolled");
        }
    });

    
    function applyCountClassOnScroll() {
        const prd_collec = document.querySelector('product-recommendations.product-recommendations--loaded  .collection');
        const rpv = document.querySelector('.extrainfo.related_prd_variant');
        if (!prd_collec || !rpv) return;

        const vprd = rpv.children.length;
        prd_collec.classList.remove('count-1','count-2','count-3','count-4','count-5');
        prd_collec.classList.add(`count-${vprd}`);

        // Remove listener once applied — no need to keep firing
        window.removeEventListener('scroll', applyCountClassOnScroll);
    }
    window.addEventListener('scroll', applyCountClassOnScroll, { passive: true });

    window.addEventListener('scroll', () => {
    const element = document.querySelector('.product-recommendations');

        if (element?.classList.contains('product-recommendations--loaded')) {
            const slider = document.querySelector('.extrainfo.related_prd_variant');
            let isDown = false;
            let startX;
            let scrollLeft;

            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {  isDown = false;   });
            slider.addEventListener('mouseup', () => {  isDown = false;   });

            slider.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();

                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 2;
                slider.scrollLeft = scrollLeft - walk;
            });
            console.log('Class found');
        }
    });
    

    if (window.innerWidth <= 1024) {
        // const elements = document.querySelectorAll('.text-block, .custom-variants, .hovercards:not(.static_text) a.button, .product-recommendations--loaded .variant-title');
        // const observer = new IntersectionObserver(
        // (entries) => {
        //     entries.forEach((entry) => {
        //     if (entry.isIntersecting) {
        //        setTimeout(() => {
        //           entry.target.classList.add('inview');
        //        }, 400); 
        //     } else {
        //         entry.target.classList.remove('inview'); // optional
        //     }
        //     });
        // },
        // { threshold: 0.5 });
        // elements.forEach((el) => observer.observe(el));


        const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
            setTimeout(() => {
                entry.target.classList.add('inview');
            }, 400);
            } else {
            entry.target.classList.remove('inview');
            }
        });
        }, {
        threshold: 0.5
        });

        function observeElements() { document.querySelectorAll('.text-block, .custom-variants, .hovercards:not(.static_text) a.button, .add-to-cart-button, .variant-title').forEach((el) => {
            if (!el.dataset.observed) {
                observer.observe(el);
                el.dataset.observed = 'true';
                }
            });
        }

        observeElements();

        const mutationObserver = new MutationObserver(() => {
            observeElements();
        });

        mutationObserver.observe(document.body, {
            childList: true,
            subtree: true
        });

        // making header fixed for mobile
        window.addEventListener("scroll", function () {
            const target = document.querySelector('header-component.header')
            if (window.scrollY > 100) {
                target.classList.add("scrolled");
            } else {
                target.classList.remove("scrolled");
            }
        });

        // Mobile sidebar drawer - menu images
         setTimeout(() => {
            const sourceContainer1 = document.querySelector('#Details-HeaderMenu-1 .mega-menu__container .mega-menu__collage');
            const targetContainer1 = document.querySelector('#link-Ac1FkQXVRT25oZXRMa__menu_tab_item_aUDAAR .menu-drawer__inner-submenu');
            const sourceContainer2 = document.querySelector('#Details-HeaderMenu-2 .mega-menu__container .mega-menu__collage');
            const targetContainer2 = document.querySelector('#link-Ad01lazYyRDdhVHZCT__menu_tab_item_gFEwXm .menu-drawer__inner-submenu');

            if (sourceContainer1 && targetContainer1) {
                [...sourceContainer1.children].forEach((el) => {
                    targetContainer1.appendChild(el);
                });
            }

            if (sourceContainer2 && targetContainer2) {
                [...sourceContainer2.children].forEach((el) => {
                    targetContainer2.appendChild(el);
                });
            }
        }, 1000); 
        /// Ended
    }

    
    
    // if (window.innerWidth <= 768) {

    //     const HeroBanner = document.querySelector('.video_banner');
    //     const textBlock = HeroBanner?.querySelector('.text-block.sm-fade-out');
    //     const video = HeroBanner?.querySelector('video');

    //     if (textBlock && video) {
    //         const fadeOut = () => {
    //             setTimeout(() => {
    //                 textBlock.classList.add('fade-out');
    //             }, 4000);
    //         };

    //         if (!video.paused && !video.ended) {  fadeOut(); }
    //         else { video.addEventListener('play', fadeOut, { once: true }); }
    //     }
    // }

});

// Sound On


// Scrollbased Animations

    function createMarkers(item, index) {
      if (!item.markers) return;

      // START MARKER
      const startMarker = document.createElement("div");
      startMarker.className = "marker start";
      startMarker.style.top = `${item.start * 100}vh`;
      startMarker.innerHTML = `START ${index + 1}`;

      // END MARKER
      const endMarker = document.createElement("div");
      endMarker.className = "marker end";
      endMarker.style.top = `${item.end * 100}vh`;
      endMarker.innerHTML = `END ${index + 1}`;

      document.body.append(
        startMarker,
        endMarker
      );
    }

    // ANIMATIONS -----------------------------------

    const animations = [
      {
        el: document.querySelector('.section.newsletter'),
        start: 0.1,
        end: 0.1,
        markers: false,
        entered: false,
        ended: false,
        mode: "top", 
        targets: {
            header: document.querySelector('header.header-section'),
        },

        // update(el, progress) {
        //   const y =  120 - progress * 120;
        //   el.style.opacity = progress;
        //   el.style.transform = `translateY(${y}px)`;
        // },

        onEnter(item) { item.targets.header.classList.add('hideHeader'); },
        // onLeave(item) { item.targets.header.classList.remove('hideHeader'); },
        // onEnd(item) { item.targets.header.classList.remove("hideHeader"); },
        onReverse(item) { item.targets.header.classList.remove("hideHeader"); }
      }

    ];

    animations.forEach(createMarkers);

    function clamp(value, min, max) {
      return Math.max(min, Math.min(value, max));
    }

    // -----------------------------------
    // MAIN UPDATE
    // -----------------------------------

    function updateScrollAnimations() {

      const vh = window.innerHeight;

      animations.forEach(item => {

        // const rect = item.el.getBoundingClientRect();
        // const start =  vh * item.start;
        // const end = vh * item.end;
        // let progress = (start - rect.top) / (start - end);
        const triggerPoint = vh * item.start;
        const endPoint = vh * item.end;
        const rect = item.el.getBoundingClientRect();
        const anchor = item.mode === "bottom" ? rect.bottom : rect.top;
        let progress = (triggerPoint - anchor) / (triggerPoint - endPoint);
        progress = clamp(progress, 0, 1);

        if (progress > 0 && !item.entered) {
          item.entered = true;
          item.onEnter?.(item);
        }

        if (progress <= 0 && item.entered) {
          item.entered = false;
          item.onLeave?.(item);
        }

        if (progress >= 1 && !item.ended) {
          item.ended = true;
          item.onEnd?.(item);
        }

        if (progress < 1 && item.ended) {
          item.ended = false;
          item.onReverse?.(item);
        }

        item.update?.(item, progress);

      });
    }

    let ticking = false;
    function handleScroll() {
      if (!ticking) { requestAnimationFrame(() => {
          updateScrollAnimations();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener("scroll", handleScroll,{ passive: true });
    window.addEventListener("resize", updateScrollAnimations);

    // Initial run
    updateScrollAnimations();


    // gallery dots

//  document.addEventListener('DOMContentLoaded', function () {
//   setTimeout(initProductGalleryDots, 800);
// });

// function initProductGalleryDots() {
//   // Target the initialized swiper directly
//   const swiperEl = document.querySelector(
//     '.swiper-initialized.swiper-horizontal.swiper-watch-progress'
//   );

//   if (!swiperEl) {
//     setTimeout(initProductGalleryDots, 500);
//     return;
//   }

//   const swiperInstance = swiperEl.swiper;
//   if (!swiperInstance) {
//     setTimeout(initProductGalleryDots, 500);
//     return;
//   }

//   // Remove old empty pagination if exists
//   const oldPag = swiperEl.querySelector('.swiper-pagination');
//   if (oldPag) oldPag.remove();

//   const totalSlides = swiperInstance.slides.length;
//   if (totalSlides <= 1) return;

//   // Create dots wrapper
//   const dotsWrap = document.createElement('div');
//   dotsWrap.className = 'custom-gallery-dots';

//   // Build dots
//   for (let i = 0; i < totalSlides; i++) {
//     const dot = document.createElement('span');
//     dot.className = 'gallery-dot' + (i === 0 ? ' gallery-dot--active' : '');
//     dot.addEventListener('click', function () {
//       swiperInstance.slideTo(i);
//     });
//     dotsWrap.appendChild(dot);
//   }

//   // Inject after the swiper element
//   swiperEl.parentNode.insertAfter
//     ? swiperEl.parentNode.insertAfter(dotsWrap, swiperEl)
//     : swiperEl.after(dotsWrap);

//   // Update active dot on slide change
//   swiperInstance.on('slideChange', function () {
//     dotsWrap.querySelectorAll('.gallery-dot').forEach(function (d, idx) {
//       d.classList.toggle('gallery-dot--active', idx === swiperInstance.realIndex);
//     });
//   });
// }

// document.addEventListener('shopify:section:load', function () {
//   initProductGalleryDots();
// });